define(function (require) {
    const tpl = require('civicsViews/share_email_view/templates/t_itv_url.hbs');

    return Marionette.ItemView.extend({
        template: tpl,
        ui: {
            sendEmailButton: '.btn-email-link',
            copyLinkButton: '.btn-share-link',
            shareURLField: '.share-url-field .input-text',
            copyText: '.copy-text'
        },
        events: {
            'click @ui.sendEmailButton': 'sendEmailClicked',
            'click @ui.copyLinkButton': 'copyURLLink',
            'focus @ui.shareURLField': 'selectURL'
        },
        initialize: function (options) {
            this.config = options.config;
            this.URLPath = options.URLPath;
            this.URLParams = options.URLParams;
            this.usesFullURLPath = options.usesFullURLPath;
            this.commonLabel = options.commonLabel;
            this.shareUrl = this.URLPath;


        },
        onShow: function () {

        },
        onRender: function () {
            this.ui.shareURLField.val(this.shareUrl);
            this.ui.shareURLField[0].setAttribute('readonly', true);
        },
        selectURL: function () {
          this.ui.shareURLField.select();
        },
        copyURLLink: function () {
          var iCopy = document.createElement("input");
          iCopy.setAttribute("value", this.shareUrl);
          document.body.appendChild(iCopy);
          iCopy.select();
          document.execCommand("copy");
          document.body.removeChild(iCopy);

          this.ui.copyText.text(i18n.t(this.commonLabel.copiedLink));
          this.ui.shareURLField.focus();
        },
        templateHelpers: function () {
            var decodedUrl;
            try {
                decodedUrl = decodeURIComponent(this.shareUrl);
            } catch (e) {
                decodedUrl = this.shareUrl;
            }
            var body = encodeURIComponent(i18n.t(this.commonLabel.emailBody,{url: decodedUrl}));
            var subject = encodeURIComponent(i18n.t(this.commonLabel.emailSubject));
            return {
                url_field: i18n.t(this.commonLabel.urlField),
                sendEmail: i18n.t(this.commonLabel.sendEmail),
                copyLink: i18n.t(this.commonLabel.copyLink),
                mailto: `mailto:?body=${body}&subject=${subject}`

            };
        }
    });
});
